import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader } from '@tigergraph/app-ui-lib/modal';
import { useStyletron } from '@tigergraph/app-ui-lib/Theme';

import { WorkspaceT } from '@/pages/workgroup/type';

export function formatCountdown(msRemaining: number): string {
  const totalSeconds = Math.max(0, Math.ceil(msRemaining / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
}

export default function AutoPauseWarningModal({
  workspace,
  msRemaining,
  isExtending,
  onKeepAlive,
  onDismiss,
}: {
  workspace: WorkspaceT;
  msRemaining: number;
  isExtending: boolean;
  onKeepAlive: () => void;
  onDismiss: () => void;
}) {
  const [css, theme] = useStyletron();

  return (
    <Modal onClose={onDismiss} isOpen={true}>
      <ModalHeader>Keep this workspace running?</ModalHeader>
      <ModalBody>
        <div className={css({ fontSize: '14px' })}>
          Workspace <strong>{workspace.name}</strong> has been idle and will pause automatically. Keep it running to
          continue working without interruption.
        </div>
        <div
          className={css({
            marginTop: '16px',
            display: 'grid',
            gridTemplateColumns: '140px 1fr',
            backgroundColor: theme.colors['background.secondary'],
            padding: '8px',
            gap: '8px',
            fontSize: '12px',
            color: theme.colors['text.secondary'],
          })}
        >
          <div>Pausing in</div>
          <div
            className={css({
              color: theme.colors['text.primary'],
              fontVariantNumeric: 'tabular-nums',
              fontWeight: 600,
            })}
          >
            {formatCountdown(msRemaining)}
          </div>
          <div>Auto suspend after</div>
          <div className={css({ color: theme.colors['text.primary'] })}>{workspace.auto_stop_minutes} minutes idle</div>
          <div>Auto-Resume</div>
          <div className={css({ color: theme.colors['text.primary'] })}>
            {workspace.enable_auto_start ? 'On' : 'Off'}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <ModalButton kind="secondary" onClick={onDismiss} disabled={isExtending}>
          Let it pause
        </ModalButton>
        <ModalButton onClick={onKeepAlive} isLoading={isExtending}>
          Keep working
        </ModalButton>
      </ModalFooter>
    </Modal>
  );
}
